
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Briefcase, Plus } from 'lucide-react';
import WorkExperienceList from '@/components/profile/WorkExperienceList';
import WorkExperienceForm from '@/components/profile/WorkExperienceForm';

interface WorkExperienceTabProps {
  userId: string;
  onRefresh: () => void;
}

const WorkExperienceTab: React.FC<WorkExperienceTabProps> = ({ userId, onRefresh }) => {
  const [showWorkExperienceForm, setShowWorkExperienceForm] = useState(false);
  const [selectedWorkExperience, setSelectedWorkExperience] = useState(null);

  const handleWorkExperienceComplete = () => {
    setShowWorkExperienceForm(false);
    setSelectedWorkExperience(null);
    onRefresh();
  };

  return (
    <Card className="border border-[#0EA5E9]/20 shadow-md bg-white/80">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Briefcase className="h-5 w-5 text-[#0EA5E9]" />
          Work Experience
        </CardTitle>
        <CardDescription>
          Add your work experience
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {showWorkExperienceForm ? (
          <WorkExperienceForm 
            userId={userId} 
            onComplete={handleWorkExperienceComplete} 
            onCancel={() => setShowWorkExperienceForm(false)} 
          />
        ) : (
          <>
            <WorkExperienceList 
              userId={userId} 
              onEdit={(exp) => {
                setSelectedWorkExperience(exp);
                setShowWorkExperienceForm(true);
              }}
              onRefresh={onRefresh}
            />
            
            <Button 
              className="bg-[#0EA5E9] text-white hover:bg-[#0EA5E9]/90"
              onClick={() => setShowWorkExperienceForm(true)}
            >
              <Plus className="h-4 w-4 mr-2" />
              Add Work Experience
            </Button>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default WorkExperienceTab;
